import React from 'react';
import { Check, X } from 'lucide-react';
import { evaluatePassword } from '../utils/passwordPolicy';

// Live-checklista som visar vad som saknas i lösenordet.
const PasswordStrengthChecklist = ({ password }) => {
  const results = evaluatePassword(password);
  const allOk = results.every((r) => r.ok);
  return (
    <ul className="space-y-1.5 mt-2" data-testid="password-checklist">
      {results.map((r) => (
        <li key={r.label} className={`flex items-center gap-2 text-xs ${r.ok ? 'text-green-700 dark:text-green-400' : 'text-muted-foreground'}`}>
          {r.ok ? <Check size={12} /> : <X size={12} className="opacity-50" />}
          <span>{r.label}</span>
        </li>
      ))}
      {allOk && (
        <li className="text-xs font-bold text-green-700 dark:text-green-400 mt-1">
          Lösenordet är starkt! 💪
        </li>
      )}
    </ul>
  );
};

export default PasswordStrengthChecklist;
